import React, { Component } from 'react';

class OpbStatus extends Component {
    handleOpbSearch = () => {
        this.props.handleOpbSearch(this.props.opbStatus);
    };

    render() {
        let icon = "ic-contract.svg";
        let kindName = "계약";
        if(this.props.opbStatus === 'ST001') {
            icon = "ic-normal.svg";
            kindName = "정상";
        } else if(this.props.opbStatus === 'ST002') {
            icon = "ic-stop.svg";
            kindName = "중단";
        } else if(this.props.opbStatus === 'ST003') {
            icon = "ic-expiration.svg";
            kindName = "만료";
        } else if(this.props.opbStatus === 'Y') {
            icon = "ic-normal.svg";
            kindName = "연결";
        } else if(this.props.opbStatus === 'N') {
            icon = "ic-stop.svg";
            kindName = "끊김";
        }

        return (
            <div className="div-table-display opbstate-status-summary" onClick={this.handleOpbSearch}>
                <div className="text-aign-right opbstate-status-icon">
                    <img src={`/assets/images/`+icon} className={`ic-`+this.props.kind} alt={kindName+`건수`}/>
                </div>
                <div className="text-align-center">
                    <div className="opbstate-status-count">{this.props.count}<span className="opbstate-status-count-suffix">건</span></div>
                    <div className="opbstate-status-title">{kindName}건수</div>
                </div>
            </div>
        )
    }
}

export default OpbStatus;